import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import BottomTab from "../../../../../components/pagination/BottomTab";

const LIMIT = 20;

function Advanced() {
  const [payment, setpayment] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const getData = useCallback(
    (pageNum: number) => {
      baseUrl
        .get("payment/getAdvancedPayment", {
          headers: {
            page: pageNum,
            limit: LIMIT,
          },
        })
        .then((response) => {
          setpayment(response.data.data || []);
          setCount(response.data.count || 0);
        })
        .catch((error) => console.log(error));
    },
    []
  );

  useEffect(() => {
    getData(page);
  }, [page, getData]);

  const onPageChange = useCallback((newPage: number) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="flex items-center gap-2.5">
        <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center">
          <TrendingUpIcon className="text-emerald-600" sx={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="text-sm font-bold text-slate-800">Advanced Payments</h3>
          <p className="text-xs text-slate-500">{count} records</p>
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        <table className="w-full">
          <thead className="bg-emerald-50 border-b border-emerald-100">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Invoice</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Patient</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Total</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Discount</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Card</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Cash</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Bank</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">paid</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Advanced</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-emerald-600 uppercase">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {payment.map((item: any, index) => (
              <tr
                key={index}
                onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
                className="hover:bg-slate-50 cursor-pointer transition-colors"
              >
                <td className="px-3 py-2 text-xs font-medium text-indigo-600">{item?.invoiceNo}</td>
                <td className="px-3 py-2 text-xs font-medium text-slate-800">{item?.patientData?.fullName}</td>
                <td className="px-3 py-2 text-xs text-slate-600">{item?.total}</td>
                <td className="px-3 py-2 text-xs text-orange-600">{item?.discount}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.card}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.cash}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.bankTransfer}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.paid}</td>
                <td className="px-3 py-2">
                  <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-md text-xs font-semibold">
                    {Math.abs(item?.due)}
                  </span>
                </td>
                <td className="px-3 py-2 text-xs text-slate-500">{item?.patientData?.updatedAt?.split("T")[0]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-2">
        {payment.map((item: any, index) => (
          <div
            key={index}
            onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
            className="bg-white rounded-lg shadow-sm border border-emerald-100 p-3 cursor-pointer"
          >
            <div className="flex items-center justify-between mb-1.5">
              <span className="font-medium text-xs text-indigo-600">{item?.invoiceNo}</span>
              <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-md text-xs font-semibold">
                +{Math.abs(item?.due)}
              </span>
            </div>
            <h3 className="font-semibold text-xs text-slate-800">{item?.patientData?.fullName}</h3>
            <p className="text-[10px] text-slate-500 mt-1">{item?.patientData?.updatedAt?.split("T")[0]}</p>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {count > LIMIT && (
        <BottomTab title="Payment" count={count} onPageChange={onPageChange} />
      )}
    </div>
  );
}

export default Advanced;
